import React from 'react';
import Card from '../../../components/Card';
import SemesterLayout from '../../../components/SemesterLayout';

const Sem3 = ({ branch = "CSE" }) => {
  const notes = [
    { title: 'Computational Methods', link: `/notes/${branch.toLowerCase()}/Computational Methods` },
    { title: 'Digital Logic and Circuit Design', link: `/notes/${branch.toLowerCase()}/Digital Logic and Circuit Design` },
    { title: 'Discrete Mathematics', link: `/notes/${branch.toLowerCase()}/Discrete Mathematics` },
    { title: 'Data Structures', link: `/notes/${branch.toLowerCase()}/ Data Structures ` },
    { title: 'Indian Knowledge Sysytem', link: `/notes/${branch.toLowerCase()}/Indian Knowledge System` },
    { title: 'Object Oriented Programming', link: `/notes/${branch.toLowerCase()}/Object Oriented Programming` }
  ];

  return (
    <SemesterLayout
      branch={branch}
      semester="3rd Semester"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {notes.map((note, index) => (
          <Card key={index} title={note.title} link={note.link} />
        ))}
      </div>
    </SemesterLayout>
  );
};

export default Sem3;
